import { __ } from '@wordpress/i18n';
import { TextControl } from '@wordpress/components';
import { applyFilters } from '@wordpress/hooks';
import ColorControl from '../../../controls/ColorControl';
const Contact = ({
	section,
	index,
	getSectionItems,
	setSectionItems,
	handleChangeSectionField,
	attributes,
	setAttributes,
}) => {
	const sectionItems = getSectionItems();
	const emailPhoneVisibility = applyFilters(
		'bwdcv-email-phone-visibility',
		true
	);
	const contactSocial = applyFilters('bwdcv.contactSocial', null, {
		sectionItems,
		setAttributes,
	});
	const {
		contactContentColor,
		style,
	} = attributes || {};
	return (
		<>
			<div className="bwdcv-contact-info-wrap">
				{emailPhoneVisibility && (
					<>
						<div className="phone-number-wrap">
							<TextControl
								label={__('Phone Number', 'cv-builder')}
								value={section.phoneNumber || ''}
								onChange={(value) =>
									handleChangeSectionField(
										value,
										index,
										'phoneNumber'
									)
								}
							/>
						</div>
						<div className="email-wrap">
							<TextControl
								label={__('Email', 'cv-builder')}
								value={section.email || ''}
								onChange={(value) =>
									handleChangeSectionField(
										value,
										index,
										'email'
									)
								}
							/>
						</div>
					</>
				)}

				<div className="address-wrap">
					<TextControl
						label={__('Address', 'cv-builder')}
						value={section.address || ''}
						onChange={(value) =>
							handleChangeSectionField(value, index, 'address')
						}
					/>
				</div>

				<div className="city-wrap">
					<TextControl
						label={__('City', 'cv-builder')}
						value={section.city || ''}
						onChange={(value) =>
							handleChangeSectionField(value, index, 'city')
						}
					/>
				</div>

				<div className="postal-code-wrap">
					<TextControl
						label={__('Postal Code', 'cv-builder')}
						value={section.postalCode || ''}
						onChange={(value) =>
							handleChangeSectionField(value, index, 'postalCode')
						}
					/>
				</div>

				<div className="website-wrap">
					<TextControl
						label={__('Website', 'cv-builder')}
						value={section.website || ''}
						onChange={(value) =>
							handleChangeSectionField(value, index, 'website')
						}
					/>
				</div>
			</div>
			{contactSocial}
			{style !== 'style26' && style !== 'style27' && style !== 'style28' && (
			<ColorControl
				label={__(
				'Contact Content Color',
				'cv-builder'
				)}
				color={contactContentColor}
				colorName="contactContentColor"
				onChange={(colorObj) => setAttributes(colorObj)}
			/>
			)}
		</>
	);
};

export default Contact;
